import { render, staticRenderFns } from "./space-home.vue?vue&type=template&id=5aa64928&scoped=true"
import script from "./space-home.vue?vue&type=script&lang=js"
export * from "./space-home.vue?vue&type=script&lang=js"
import style0 from "./space-home.vue?vue&type=style&index=0&id=5aa64928&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa64928",
  null
  
)

export default component.exports